import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './Blog.css';

const Blog = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchBlogs = async () => {
        try {
            console.log('Fetching blogs...');
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/blog`); // Direct use of process.env
            console.log('Blogs fetched:', response.data);
            setBlogs(response.data);
        } catch (err) {
            setError('Error fetching blogs');
            console.error('Error fetching blogs:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBlogs();
    }, []);

    if (loading) return <div className="loading-message">Loading blogs...</div>;
    if (error) return <div className="error-message">{error}</div>;
    if (blogs.length === 0) return <div className="no-blogs-message">No blogs available yet. Check back later!</div>;

    return (
        <div className="blog-container">

<div className="homepage-header">
        {/* Include the image */}
        <img
          className="homepage-image2"
          src="/images/wf-blog.png"
          alt="Person meditating"
        />
      </div>
            
            {blogs.map((blog) => {
                const totalReplies = blog.comments.reduce(
                    (count, comment) => count + (comment.replies ? comment.replies.length : 0),
                    0
                );

                return (
                    <div key={blog._id} className="blog-card">
                        <h3 className="blog-card-title">
                            <Link to={`/blog/${blog._id}`} className="blog-card-link">
                                {blog.title}
                            </Link>
                        </h3>

                        {/* Correct Image Display */}
                        {blog.images && blog.images.length > 0 ? (
                            <img
                                src={`${process.env.REACT_APP_API_URL}${blog.images[0]}`} // Using process.env for image URL
                                alt="Blog"
                                className="all-blog-card-image"
                            />
                        ) : (
                            <p className="no-image-text">No image available</p>
                        )}

                        <div
                            className="blog-card-content"
                            dangerouslySetInnerHTML={{
                                __html: blog.content.substring(0, 150) + '...',
                            }}
                        />
                        <p className="blog-date">
                            <strong>Published :</strong> {new Date(blog.createdAt).toLocaleDateString()}
                        </p>
                        <p className="blog-category">
                            <strong>Category :</strong> {blog.category}
                        </p>

                        {/* Comments summary */}
                        <div className="comments-summary">
                            <Link to={`/blog/${blog._id}`} className="comments-summary-link">
                                {blog.comments.length} Comments, {totalReplies} Replies
                            </Link>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Blog;
